import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { openPopupWindow, formatNumber } from 'helpers/generic';

const DuplicatedWarningStyled = styled.div`
    h4 {
        font-size: 16px;
    }

    ul {
        li {

            a {
                color: unset;
                text-decoration: none;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
`;

let axiosCancelToken = null;

export default function DuplicatedWarning(props) {
    const {invoiceId, providerId, date, number} = props;

    const [duplicated, setDuplicated] = useState(false);
    const [invoices, setInvoices] = useState([]);

    useEffect(() => {
        axiosCancelToken = axios.CancelToken.source();

        const checkIfDuplicated = async () => {
            await axios.get('/api/manager/providers-invoices/check-duplicated', {
                params: {
                    invoice_id: invoiceId,
                    provider_id: providerId,
                    date: date,
                    number: number
                },
                cancelToken: axiosCancelToken.token
            }).then((response) => {
                setDuplicated(response.data.duplicated);
                setInvoices(response.data.invoices);
            }).catch((error) => {
                if ( axios.isCancel(error) ) return;
            });
        }
        checkIfDuplicated();

        return function cleanup() {
            axiosCancelToken.cancel();
        }
    }, [invoiceId, providerId, date, number]);

    const openInvoiceOnPopup = (e) => {
        e.preventDefault();

        const url = e.currentTarget.href;
        openPopupWindow(url, 'invoice');
    }

    return (
        <>
            {duplicated === true &&
                <DuplicatedWarningStyled className="alert alert-danger mb-0">
                    <h4><i className="fa fa-exclamation-triangle"></i> <b>¡Atención!</b> Esta factura puede estar repetida</h4>
                    {invoices.length > 0 &&
                        <ul className="mb-0 mt-4">
                            {invoices.map((invoice) => (
                                <li key={invoice.id}>
                                    <NavLink to={`/providers-invoices/edit/${invoice.id}?popup=true&disable_proxy_popup_callback=true`} onClick={openInvoiceOnPopup}>
                                        <b>Factura Nº {invoice.number}</b> del <b>{moment(invoice.date).format('DD-MM-YYYY')}</b> de <b>{formatNumber(invoice.total)} €</b>
                                    </NavLink>
                                </li>
                            ))}
                        </ul>
                    }
                </DuplicatedWarningStyled>
            }
        </>
    );
}